import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;
const BACKEND_URL_CSRF = process.env.REACT_APP_LARAVEL_API_CSRF;

// Async thunk for login
export const login = createAsyncThunk("clientAuth/login", async (FormData, thunkAPI) => {
    try {
        const res = await axios.post(
            `${BACKEND_URL}/userlogin`,
            FormData,
            { withCredentials: true },
        );
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
});

export const forgotPassword = createAsyncThunk(
    "auth/forgotPassword",
    async (email, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("email", email);

            const response = await axios.post(
                `${BACKEND_URL}/forget-password`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Something went wrong"
            );
        }
    }
);

export const resetPassword = createAsyncThunk(
    "clientAuth/resetPassword",
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            formData.append("token", data.token);
            formData.append("email", data.email);
            formData.append("password", data.password);
            formData.append("password_confirmation", data.password_confirmation);

            const response = await axios.post(
                `${BACKEND_URL}/reset-password`,
                formData
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Reset failed");
        }
    }
);

export const getToken = createAsyncThunk("clientAuth/login", async (FormData, thunkAPI) => {
    try {
        const res = await axios.get(
            `${BACKEND_URL_CSRF}/sanctum/csrf-cookie`, {
            withCredentials: true,
        }
        );
        console.log("res", res);
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
});

export function saveTokenInLocalStorage(access_token) {
    console.log("access_token", access_token);
    localStorage.setItem("token", access_token);
}

const authFromStorage = localStorage.getItem("token");
const authSlice = createSlice({
    name: "clientAuth",
    initialState: {
        auth: authFromStorage ? { access_token: authFromStorage } : null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
            state.auth = null;
            state.loading = false;
            state.error = null;

            localStorage.removeItem("token");
            localStorage.removeItem("user_id");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.auth = action.payload;
                state.error = null;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(forgotPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(forgotPassword.fulfilled, (state) => {
                state.loading = false;
            })

            .addCase(forgotPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(resetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(resetPassword.fulfilled, (state) => {
                state.loading = false;
            })

            .addCase(resetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { logout } = authSlice.actions;
export const selectWorkerAuth = (state) => !!state.workerAuth.auth;
export default authSlice.reducer;
